var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.status && _vm.auth
    ? _c(
        "div",
        { staticStyle: { display: "inline-block" } },
        [
          _c(
            "p",
            {
              staticClass: "blue-red-hover-text",
              on: { click: _vm.openMeasuresModal },
            },
            [_vm._v("Меры поддержки")]
          ),
          _vm._v(" "),
          _vm.showModal
            ? _c(
                "modal",
                {
                  attrs: {
                    close: function () {
                      _vm.showModal = false
                    },
                    printButton: false,
                    downloadButton: false,
                  },
                },
                [
                  _c("template", { slot: "modalHeader" }, [
                    _c("i", { staticClass: "uk-icon-hand-o-up" }),
                    _vm._v("  Меры поддержки субъекта МСП"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "measures-modal-body",
                      attrs: { slot: "modalBody" },
                      slot: "modalBody",
                    },
                    [
                      _vm.loading
                        ? _c("shestirenkaLoader")
                        : [
                            _c(
                              "p",
                              { staticClass: "measures-modal-content-header" },
                              [
                                _vm._v(
                                  "Согласно федеральному закону 209-ФЗ (статья 8) от 24.07.2007 «О развитии малого и среднего предпринимательства в РФ», организация является получателем следующих видов поддержки:"
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.measures, function (e, i) {
                              return _c(
                                "div",
                                {
                                  key: i,
                                  staticClass: "measures-modal-content-item",
                                },
                                [
                                  _c("p", [
                                    _c("b", [_vm._v(_vm._s(e.form_title))]),
                                    _vm._v(
                                      " – " +
                                        _vm._s(e.view_title) +
                                        " в размере " +
                                        _vm._s(e.size) +
                                        " " +
                                        _vm._s(e.unit_title)
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _c("b", [
                                      _vm._v(
                                        "Орган, предоставивший поддержку:"
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    e.ogrn_pp
                                      ? _c(
                                          "a",
                                          {
                                            attrs: {
                                              target: "_blank",
                                              href: "/company/" + e.ogrn_pp,
                                            },
                                          },
                                          [_vm._v(_vm._s(e.name_pp) + ".")]
                                        )
                                      : _c("span", [
                                          _vm._v(_vm._s(e.name_pp) + "."),
                                        ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _c("b", [
                                      _vm._v("Срок оказания поддержки:"),
                                    ]),
                                    _vm._v(
                                      " " +
                                        _vm._s(e.date_start) +
                                        " – " +
                                        _vm._s(e.date_support)
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  e.violations == 1
                                    ? _c(
                                        "p",
                                        {
                                          staticClass:
                                            "measures-modal-content-danger",
                                        },
                                        [
                                          _vm._v(
                                            "Имеется информация о наличии нарушения порядка и условий предоставления поддержки."
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  e.untargeted == 1
                                    ? _c(
                                        "p",
                                        {
                                          staticClass:
                                            "measures-modal-content-danger",
                                        },
                                        [
                                          _vm._v(
                                            "Имеется информация о нецелевом использовании средств поддержки."
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("hr"),
                                ]
                              )
                            }),
                          ],
                    ],
                    2
                  ),
                ],
                2
              )
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }